/**
 * Chọn body của mail template theo trường "UV lạ/quen" (FlowCategory.candidate_know_state).
 *
 * Giá trị khớp choices ở backend (candidate/models.py):
 *      1 = N/A, 2 = Lạ, 3 = UV quen chưa giới thiệu GP, 4 = UV quen đã giới thiệu GP
 *
 * Lưu ý: tab "Email 2 - giới thiệu" (email2_instructor_body) KHÔNG thuộc nhóm này —
 * đó là mail số 2 chứ không phải một biến thể của UV lạ/quen, nên không chọn ở đây.
 */

import { CANDIDATE_KNOW_STATE } from '@app/constants/Common';

export const CandidateKnowState = {
    NA: 1,
    STRANGE: 2,
    KNOW_NOT_INSTRUCT_GP: 3,
    KNOW_INSTRUCT_GP: 4,
};

export const selectTemplateBody = (template, knowState) => {
    if (!template) return '';

    // API trả về lúc là số, lúc là chuỗi ('4') tuỳ endpoint nên phải ép kiểu trước khi so.
    // Giá trị lạ/rỗng -> NaN -> dùng body mặc định của UV lạ.
    const state = Number(knowState);

    if (state === CandidateKnowState.KNOW_NOT_INSTRUCT_GP) {
        return template.not_gp_candidate_body || template.strangle_candidate_body || '';
    }
    if (state === CandidateKnowState.KNOW_INSTRUCT_GP) {
        return template.gp_candidate_body || template.strangle_candidate_body || '';
    }
    return template.strangle_candidate_body || '';
};

/**
 * Lấy candidate_know_state từ response của /candidate/detail/flow.
 *
 * KHÔNG lấy từ candidate.flow_categories của /candidate/list/: endpoint đó chỉ trả
 * candidate_know_state khi export Excel, request thường luôn thiếu field này (nên trước đây
 * mọi UV đều rơi về body "UV lạ"). Ngoài ra bản ghi FlowCategory có thể có nhiều dòng cho
 * cùng 1 UV, endpoint detail/flow mới là chỗ áp đúng luật lọc theo user đang đăng nhập.
 */
/**
 * Nhãn hiển thị của "UV lạ/quen". Dùng chung mảng CANDIDATE_KNOW_STATE (index = giá trị)
 * với màn hình Person detail để nhãn không bị lệch nhau giữa các màn.
 */
export const knowStateLabel = (knowState) => {
    const state = Number(knowState);
    if (!Number.isInteger(state)) return '';
    return CANDIDATE_KNOW_STATE[state] || '';
};

export const readKnowStateFromFlowDetail = (flowContent) => (
    flowContent && flowContent.candidate_know_state !== undefined && flowContent.candidate_know_state !== null
        ? flowContent.candidate_know_state
        : undefined
);

// [SPEC: TEST Gửi Email qua PM - DVTJCUV 5 - BS2]
export const isEligibleForIntroEmail = (knowState, alreadySentIntro) => {
    const state = Number(knowState);
    const isStrangeOrNotGp = state === CandidateKnowState.STRANGE || state === CandidateKnowState.KNOW_NOT_INSTRUCT_GP;
    return isStrangeOrNotGp && !alreadySentIntro;
};

export const readSentIntroFromFlowDetail = (flowContent, isRec) => (
    Boolean(flowContent && (isRec ? flowContent.sent_intro_email_rec : flowContent.sent_intro_email_uv))
);
